<template>
  <div class="hero">
    <div class="container">
      <div class="row">
        <div class="col-md-6 text-hero" style="margin-bottom: 20px">
          <h2 v-if="false">
            <span style="color: black">Track </span>
            <span style="color: #ffc728">Progress</span>
          </h2>
          <p>
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="9" cy="9" r="9" fill="#222222" />
              <path
                d="M13.2936 7.0955C13.2586 7.20098 13.2029 7.2984 13.1298 7.38203L8.96309 12.382C8.88897 12.4709 8.79713 12.5434 8.69344 12.5949C8.58974 12.6464 8.47646 12.6757 8.36082 12.6809C8.24518 12.6862 8.12971 12.6673 8.02177 12.6254C7.91384 12.5836 7.81581 12.5197 7.73393 12.4379L5.23393 9.93786C5.08213 9.7807 4.99813 9.57019 5.00003 9.3517C5.00193 9.1332 5.08957 8.92419 5.24408 8.76968C5.39858 8.61518 5.6076 8.52753 5.82609 8.52564C6.04459 8.52374 6.25509 8.60773 6.41226 8.75953L8.26643 10.6145L11.8498 6.31536C11.9188 6.22832 12.0046 6.15596 12.102 6.10256C12.1995 6.04915 12.3066 6.01577 12.4172 6.00439C12.5277 5.993 12.6394 6.00383 12.7457 6.03625C12.852 6.06867 12.9507 6.12201 13.0361 6.19315C13.1214 6.26429 13.1917 6.35178 13.2427 6.45047C13.2938 6.54917 13.3246 6.65708 13.3333 6.76785C13.3421 6.87863 13.3285 6.99003 13.2936 7.0955Z"
                fill="#e2b6ff"
              />
            </svg>
            <strong> Sign Up:</strong> Create your HeartBeatFam account and
            establish profiles for your loved ones, caregivers, and family
            members.
          </p>
          <p>
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="9" cy="9" r="9" fill="#222222" />
              <path
                d="M13.2936 7.0955C13.2586 7.20098 13.2029 7.2984 13.1298 7.38203L8.96309 12.382C8.88897 12.4709 8.79713 12.5434 8.69344 12.5949C8.58974 12.6464 8.47646 12.6757 8.36082 12.6809C8.24518 12.6862 8.12971 12.6673 8.02177 12.6254C7.91384 12.5836 7.81581 12.5197 7.73393 12.4379L5.23393 9.93786C5.08213 9.7807 4.99813 9.57019 5.00003 9.3517C5.00193 9.1332 5.08957 8.92419 5.24408 8.76968C5.39858 8.61518 5.6076 8.52753 5.82609 8.52564C6.04459 8.52374 6.25509 8.60773 6.41226 8.75953L8.26643 10.6145L11.8498 6.31536C11.9188 6.22832 12.0046 6.15596 12.102 6.10256C12.1995 6.04915 12.3066 6.01577 12.4172 6.00439C12.5277 5.993 12.6394 6.00383 12.7457 6.03625C12.852 6.06867 12.9507 6.12201 13.0361 6.19315C13.1214 6.26429 13.1917 6.35178 13.2427 6.45047C13.2938 6.54917 13.3246 6.65708 13.3333 6.76785C13.3421 6.87863 13.3285 6.99003 13.2936 7.0955Z"
                fill="#e2b6ff"
              />
            </svg>
            <strong> Connect: </strong>Invite healthcare providers, caregivers,
            and family members to join your care network. Begin sharing
            information, coordinating care, and enhancing family communication.
          </p>
          <p>
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="9" cy="9" r="9" fill="#222222" />
              <path
                d="M13.2936 7.0955C13.2586 7.20098 13.2029 7.2984 13.1298 7.38203L8.96309 12.382C8.88897 12.4709 8.79713 12.5434 8.69344 12.5949C8.58974 12.6464 8.47646 12.6757 8.36082 12.6809C8.24518 12.6862 8.12971 12.6673 8.02177 12.6254C7.91384 12.5836 7.81581 12.5197 7.73393 12.4379L5.23393 9.93786C5.08213 9.7807 4.99813 9.57019 5.00003 9.3517C5.00193 9.1332 5.08957 8.92419 5.24408 8.76968C5.39858 8.61518 5.6076 8.52753 5.82609 8.52564C6.04459 8.52374 6.25509 8.60773 6.41226 8.75953L8.26643 10.6145L11.8498 6.31536C11.9188 6.22832 12.0046 6.15596 12.102 6.10256C12.1995 6.04915 12.3066 6.01577 12.4172 6.00439C12.5277 5.993 12.6394 6.00383 12.7457 6.03625C12.852 6.06867 12.9507 6.12201 13.0361 6.19315C13.1214 6.26429 13.1917 6.35178 13.2427 6.45047C13.2938 6.54917 13.3246 6.65708 13.3333 6.76785C13.3421 6.87863 13.3285 6.99003 13.2936 7.0955Z"
                fill="#e2b6ff"
              />
            </svg>
            <strong> Personalize Your Experience: </strong> Leverage the power
            of AI and a diverse range of tracking apps to tailor the platform to
            your loved ones' unique needs. Access cognition games for mental
            stimulation, communication tools for staying in touch, and
            healthcare management apps for comprehensive care. Customize their
            journey, enhancing their comfort and well-being.
          </p>
          <p>
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="9" cy="9" r="9" fill="#222222" />
              <path
                d="M13.2936 7.0955C13.2586 7.20098 13.2029 7.2984 13.1298 7.38203L8.96309 12.382C8.88897 12.4709 8.79713 12.5434 8.69344 12.5949C8.58974 12.6464 8.47646 12.6757 8.36082 12.6809C8.24518 12.6862 8.12971 12.6673 8.02177 12.6254C7.91384 12.5836 7.81581 12.5197 7.73393 12.4379L5.23393 9.93786C5.08213 9.7807 4.99813 9.57019 5.00003 9.3517C5.00193 9.1332 5.08957 8.92419 5.24408 8.76968C5.39858 8.61518 5.6076 8.52753 5.82609 8.52564C6.04459 8.52374 6.25509 8.60773 6.41226 8.75953L8.26643 10.6145L11.8498 6.31536C11.9188 6.22832 12.0046 6.15596 12.102 6.10256C12.1995 6.04915 12.3066 6.01577 12.4172 6.00439C12.5277 5.993 12.6394 6.00383 12.7457 6.03625C12.852 6.06867 12.9507 6.12201 13.0361 6.19315C13.1214 6.26429 13.1917 6.35178 13.2427 6.45047C13.2938 6.54917 13.3246 6.65708 13.3333 6.76785C13.3421 6.87863 13.3285 6.99003 13.2936 7.0955Z"
                fill="#e2b6ff"
              />
            </svg>
            <strong> Manage: </strong> Access a centralized dashboard to oversee
            health records, medications, appointments, and care plans. Utilize
            cognitive improvement tools and activities for patients.
          </p>
          <p>
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="9" cy="9" r="9" fill="#222222" />
              <path
                d="M13.2936 7.0955C13.2586 7.20098 13.2029 7.2984 13.1298 7.38203L8.96309 12.382C8.88897 12.4709 8.79713 12.5434 8.69344 12.5949C8.58974 12.6464 8.47646 12.6757 8.36082 12.6809C8.24518 12.6862 8.12971 12.6673 8.02177 12.6254C7.91384 12.5836 7.81581 12.5197 7.73393 12.4379L5.23393 9.93786C5.08213 9.7807 4.99813 9.57019 5.00003 9.3517C5.00193 9.1332 5.08957 8.92419 5.24408 8.76968C5.39858 8.61518 5.6076 8.52753 5.82609 8.52564C6.04459 8.52374 6.25509 8.60773 6.41226 8.75953L8.26643 10.6145L11.8498 6.31536C11.9188 6.22832 12.0046 6.15596 12.102 6.10256C12.1995 6.04915 12.3066 6.01577 12.4172 6.00439C12.5277 5.993 12.6394 6.00383 12.7457 6.03625C12.852 6.06867 12.9507 6.12201 13.0361 6.19315C13.1214 6.26429 13.1917 6.35178 13.2427 6.45047C13.2938 6.54917 13.3246 6.65708 13.3333 6.76785C13.3421 6.87863 13.3285 6.99003 13.2936 7.0955Z"
                fill="#e2b6ff"
              />
            </svg>
            <strong> Stay Informed:</strong> Receive real-time updates on your
            loved one's health and care, ensuring you're always well-informed.
          </p>
        </div>
        <div class="col-md-6 img-hero">
          <img src="../../assets/img/home/how-it-works.png" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SocialMarketing"
};
</script>

<style lang="scss" scoped>
.hero {
  min-height: 452px;
  background-color: #ffffff;
  font-family: "Lato";
  .container {
    .text-hero {
      min-height: 452px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      h2 {
        font-style: normal;
        font-weight: bold;
        font-size: 32px;
        line-height: 44px;
        color: #474d52;
        margin-bottom: 20px;
      }
      p {
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 22px;
        color: #474d52;
        font-family: "Lato";
      }
      .btn {
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 19px;
        letter-spacing: 0.1em;
        text-transform: capitalize;
      }
    }
    .img-hero {
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        height: 500px;
        // margin: 40px 0;
      }
    }
  }
}

@media (max-width: 640px) {
  .hero {
    .container {
      .text-hero {
        min-height: unset;
        padding-top: 30px;
        h1 {
          font-size: 60px !important;
          line-height: 70px !important;
        }
      }
      .img-hero svg {
        height: 260px;
        margin: 40px 0;
      }
      .img-hero img {
        height: 260px;
        margin: 40px 0;
      }
    }
  }

  .how-to-header {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 100px;
    gap: 24px;

    position: absolute;
    width: 358px;
    height: 72px;
    left: 541px;
    top: 96px;

    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
  }
}

@media (min-width: 768px) and (max-width: 1024px) {
  .hero {
    min-height: 500px; /* Reduced height to limit extra space */
    padding: 20px 0; /* Minimized top and bottom padding */
    .container {
      .text-hero {
        padding: 0 20px; /* Side padding only, no extra top/bottom padding */
        h2 {
          font-size: 28px;
          line-height: 34px;
          margin-bottom: 12px; /* Reduced margin below heading */
        }
        p {
          font-size: 16px;
          line-height: 22px;
          margin-bottom: 8px; /* Tightened space between paragraphs */
        }
      }
      .img-hero {
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          height: 400px; /* Slightly smaller image height */
          margin: 10px 0; /* Reduced vertical margin */
        }
      }
    }
  }
}

</style>
